import {
  VisaIcon,
  AmexIcon,
  MasterCardIcon,
  DiscoverIcon,
} from "../components/icons";

export function getPaymentIcon(method) {
  switch (method) {
    case "visa":
      return <VisaIcon width={50} height={32} />; // Adjust width/height as needed
    case "mastercard":
      return <MasterCardIcon width={50} height={32} />;
    case "americanExpress":
      return <AmexIcon width={50} height={32} />;
    case "discover":
      return <DiscoverIcon width={50} height={32} />;
    default:
      return null;
  }
}
